var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column"},[_c('h1',[_vm._v("404 Error")]),_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v(" Go to home page ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }